import { Interpolation } from "@emotion/core";
import { Fonts } from "../../design-tokens/fonts";
import { Colors } from "../../design-tokens/colors";
import { Border } from "../../design-tokens/borders";
import { grid } from "../../design-tokens/grid";
import { Keyframes } from "../../design-tokens/animation";
import { Device } from "../../design-tokens/media-queries";
import { BoxShadow } from "../../design-tokens/box-shadow";

const root: Interpolation = {
  position: "relative",
  color: Colors.White,
  backgroundColor: Colors.DarkBlue,
  padding: `${grid(2)} ${grid(3)} ${grid(2.5)} ${grid(2)}`,
  boxShadow: BoxShadow.Default,
  borderRadius: Border.RadiusLg,
  transition: "all 0.2s ease",
  animation: `${Keyframes.FadeIn} 0.3s linear`,
  overflow: "hidden",

  "&:hover": {
    textDecoration: "none",
    transform: "translateY(-3px)",
    boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.05)",
  },
};

const content: Interpolation = {
  position: "relative",
  maxWidth: grid(26),
  zIndex: 2,

  [Device.TabletMobile]: {
    maxWidth: grid(20),
  },

  [Device.MobilePortXs]: {
    maxWidth: grid(18),
  },
};

const heading: Interpolation = {
  fontSize: "24px",
  lineHeight: "30px",
  fontWeight: Fonts.Weight.Bold,
  marginBottom: grid(2),

  [Device.Mobile]: {
    fontSize: "20px",
    lineHeight: "26px",
  },
};

const blob1: Interpolation = {
  position: "absolute",
  right: 0,
  zIndex: 0,
};

const blob1Top: Interpolation = {
  top: -30,
};

const blob1Bottom: Interpolation = {
  bottom: -20,
};

const blob2: Interpolation = {
  position: "absolute",
  right: -10,
  zIndex: 1,
};

const blob2Top: Interpolation = {
  top: -20,
};

const blob2Bottom: Interpolation = {
  bottom: -30,
};

const image: Interpolation = {
  position: "absolute",
  right: 0,
  bottom: 0,
  maxWidth: grid(17),
  zIndex: 3,

  [Device.TabletMobile]: {
    right: grid(-1),
    maxWidth: grid(16),
  },

  [Device.MobilePortXs]: {
    right: grid(-3),
    maxWidth: grid(13),
  },
};

const imageTop: Interpolation = {
  top: 0,
};

const imageBottom: Interpolation = {
  bottom: 0,
};

const styles = {
  root,
  content,
  heading,
  blob1,
  blob1Top,
  blob1Bottom,
  blob2,
  blob2Top,
  blob2Bottom,
  image,
  imageTop,
  imageBottom,
};

export default styles;
